import React, { useState } from 'react';
import OrangeButton from './OrangeButton';
import './ContactFormTwo.scss';


function ContactFormTwo() {
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [contactNumber, setContactNumber] = useState('');
    const [email, setEmail] = useState('');
    const [whatSource, setWhatSource] = useState('');
    const [yourMessage, setYourMessage] = useState('');
    const [privacyPolicyAccepted, setPrivacyPolicyAccepted] = useState(false);


    const handleFirstNameChange = (e) => {
        setFirstName(e.target.value);
    };

    const handleLastNameChange = (e) => {
        setLastName(e.target.value);
    };

    const handleContactNumberChange = (e) => {
        setContactNumber(e.target.value);
    };

    const handleEmailChange = (e) => {
        setEmail(e.target.value);
    };

    const handleWhatSourceChange = (e) => {
        setWhatSource(e.target.value);
    };

    const handleYourMessageChange = (e) => {
        setYourMessage(e.target.value);
    };

    const handlePrivacyPolicyChange = (e) => {
        setPrivacyPolicyAccepted(e.target.checked);
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!firstName || !lastName || !email || !yourMessage) {
            alert('Please fill in all the required fields of the form.');
            return;
        }

        if (!privacyPolicyAccepted) {
            alert('Please accept the Privacy Policy and cookies before submitting the form.');
            return;
        }

        const fd = new FormData();
        fd.append('firstName', firstName);
        fd.append('lastName', lastName);
        fd.append('email', email);
        fd.append('ContactNumber', contactNumber);
        fd.append('whatSource', whatSource);
        fd.append('yourMessage', yourMessage);

        fetch('https://bluecoaststudio.mu/contact.php', {
            mode: 'no-cors',
            method: 'POST',
            body: fd,
            data: fd
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error('An error occurred while submitting the form.');
                }
                return response.json();
            })
            .then((data) => {
                console.log('Odpowiedź serwera:', data.error);
                // Wykonaj odpowiednie działania po wysłaniu formularza
                alert('The form has been submitted.');
            })
            .catch((error) => {
                console.error('An error occurred while submitting the form.:', error);
            });
    };

    const handleXClick = () => {
        const contactPopup = document.querySelector('.contact-popup');
        if (contactPopup) {
            if (contactPopup.classList.contains('contact-popup-active')) {
                contactPopup.classList.remove('contact-popup-active');
            }
            else {
                contactPopup.classList.add('contact-popup-active');
            }
        }

    };

    return (
        <div className='contact-form-main-container'>
            <div className='contact-left'>

            </div>
            <div className='contact-right'>
                <form className='contact-form-two' onSubmit={handleSubmit}>
                    <div className='contact-tittle-div'>
                        
                            <h2 className='contact-title'>Send us a message</h2>
                        
                        <span className='contact-x' onClick={handleXClick}>x</span>
                    </div>
                    
                        <h4 className='contact-description'>Prefer e-mail? office@bluecoast.com</h4>
                    
                    <div className='contact-first-name'>
                        
                            <label className='contact-label' htmlFor='first_name'>First name*</label>
                            
                            
                        <input
                            className='contact-input'
                            placeholder='Enter first name'
                            id='first_name'
                            value={firstName}
                            onChange={handleFirstNameChange}
                        />
                    </div>
                    <div className='contact-last-name'>
                        
                            <label htmlFor='last_name' className='contact-label'>Last name*</label>
                            
                        <input
                            className='contact-input'
                            placeholder='Enter last name'
                            id='last_name'
                            value={lastName}
                            onChange={handleLastNameChange}
                        />
                    </div>
                    <div className='contact-email'>
                        
                            <label htmlFor='email' className='contact-label'>Your e-mail*</label>
                            
                        <input
                            className='contact-input'
                            placeholder='Enter e-mail'
                            id='email'
                            value={email}
                            onChange={handleEmailChange}
                        />
                    </div>
                    <div className='contact-phone-nr'>
                        
                            <label htmlFor='phone' className='contact-label'>Phone number</label>
                        
                        <input
                            className='contact-input'
                            id='phone'
                            placeholder='+1 212-555-1234'
                            value={contactNumber}
                            onChange={handleContactNumberChange}
                        />
                    </div>
                    <div className='contact-what-source'>
                        
                            <label htmlFor='source' className='contact-label'>How did you hear about us</label>
                        
                        <input
                            className='contact-input'
                            id='source'
                            placeholder=''
                            value={whatSource}
                            onChange={handleWhatSourceChange}
                        />
                    </div>
                    <div className='contact-your-message'>
                        
                            <label htmlFor='message' className='contact-label'>How can we help?*</label>
                            
                        <textarea
                            className='contact-input'
                            id='message'
                            placeholder=''
                            rows={15}
                            value={yourMessage}
                            onChange={handleYourMessageChange}
                        />
                    </div>
                    <div className='contact-privacy-checkbox'>
                        <input
                            type='checkbox'
                            id='privacyPolicy'
                            checked={privacyPolicyAccepted}
                            onChange={handlePrivacyPolicyChange}
                        />
                        
                        <label className='contact-priv-policy' htmlFor='privacyPolicy'>
                            I have read and accept the Privacy Policy & Cookie Policy. *
                        </label>
                        
                    </div>
                    <div className='button-send-two'>
                        <OrangeButton text='Send message' type='submit'/>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default ContactFormTwo;
